import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import ItemCalenderTime from '../../atoms/Calendar/ItemCalenderTime';
import DateTimeInput from '../../atoms/Calendar/DateTimeInput';
import { AlarmDatas } from '../AlarmSummary/AlarmSummaryGrid';
import dayjs from 'dayjs';
import GroupBox from './GroupBox';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../function/useModal';
import MessageStyleDialog, { MessageStyleDialogResponse } from '../../atoms/Dialog/MessageStyleDialog';

type AlarmHistoryHeaderProps = {
  setAlarmList: Dispatch<SetStateAction<AlarmDatas | undefined>>;
  setSearchRange: Dispatch<SetStateAction<string>>;
  exportButton: () => void;
};

const useStyles = makeStyles(
  createStyles({
    title: {
      textAlign: 'center',
      marginTop: '8px',
    },
    button: {
      maxWidth: '100px',
      maxHeight: '35px',
      minWidth: '100px',
      minHeight: '35px',
      marginTop: '15px',
      marginLeft: '40px',
      alignItems: 'center',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    checkstyle: {
      height: '5px',
    },
    searchName: {
      margin: '4px',
    },
  })
);

const AlarmHistoryHeader: React.FC<AlarmHistoryHeaderProps> = (props: AlarmHistoryHeaderProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [rangeFrom, setRangeFrom] = useState<string>('');
  const [rangeTo, setRangeTo] = useState<string>('');
  const [flgHeavy, setFlgHeavy] = useState<boolean>(true);
  const [flgLight, setFlgLight] = useState<boolean>(true);
  const [flgSystem, setFlgSystem] = useState<boolean>(true);
  //const [flgMotor, setFlgMotor] = useState<boolean>(true);
  const [devNo, setDevNo] = useState<string>('');
  const [devName, setDevName] = useState<string>('');
  const [itmName, setItmName] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const [count, setCount] = useState<number>(100);
  const [enableExport, setEnableExport] = useState<boolean>(false);

  const [flgMsgDlg, actMsgDlg] = useModal<MessageStyleDialogResponse>();
  const [dlgtitle, setDlgtitle] = useState<string>('');
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const msgdlg = flgMsgDlg ? <MessageStyleDialog dialog={actMsgDlg} title={dlgtitle} message={dlgmsg} /> : null;

  useEffect(() => {
    const now: Date = new Date();
    const from = dayjs(now).subtract(1, 'month').format('YYYY-MM-DD HH:mm');
    const to = dayjs(now).format('YYYY-MM-DD HH:mm');

    setRangeFrom(from);
    setRangeTo(to);
  }, []);

  const updateCount = (prm: string) => {
    if (prm) {
      /* 数値以外が入ってきた場合は0を返す */
      if (isNaN(parseInt(prm))) {
        setCount(0);
      } else {
        setCount(parseInt(prm));
      }
    } else {
      setCount(0);
    }
  };

  const searchAlarm = () => {
    console.log(
      'search:',
      rangeFrom,
      rangeTo,
      count,
      flgHeavy,
      flgLight,
      flgSystem,
      //flgMotor,
      devNo,
      devName,
      itmName,
      search
    );

    const devNoP = devNo === '' ? '-' : devNo;
    const devNameP = devName === '' ? '-' : devName;
    const itmNameP = itmName === '' ? '-' : itmName;
    const searchP = search === '' ? '-' : search;

    var url = `api/AlarmHistory/${rangeFrom}/${rangeTo}/${count}/${flgHeavy ? '1' : '0'}/${flgLight ? '1' : '0'}/${flgSystem ? '1' : '0'
      }/${devNoP}/${devNameP}/${itmNameP}/${searchP}`;
    console.debug(` AlarmHistoryHeader -- ${url}`);
    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(` ${url} : get data server error  status:${res.status}`);
        return res.json();
      })
      .then((result: AlarmDatas) => {
        console.debug(result);
        result.forEach((item, idx) => {
          item.rowno = idx + 1;
          item.ALM_SMM_DAT.CHECKED = 1;
        });
        props.setAlarmList(result);
        props.setSearchRange(`${rangeFrom}_${rangeTo}`);
        setEnableExport(result.length > 0);
      })
      .catch((error) => {
        setDlgtitle(t('AlarmHistoryHeader.データ取得エラー', 'データ取得エラー'));
        let msg = t('AlarmHistoryHeader.データ取得中にエラーが発生', 'データ取得中にエラーが発生しました') + '\r\n';
        msg += error;
        setDlgmsg(msg);
        actMsgDlg.open();
        console.error(error);
      });
  };

  return (
    <>
      <Grid container>
        <Grid container>
          <Grid container xs={10}>
            <GroupBox name={t('AlarmHistoryHeader.日付', '日付')} style={{ margin: '4px' }}>
              <DateTimeInput initialValue={rangeFrom} onDateTimeChange={setRangeFrom} />
              <span style={{ margin: '2px 8px' }}>～</span>
              <DateTimeInput initialValue={rangeTo} onDateTimeChange={setRangeTo} />
            </GroupBox>

            <GroupBox name={t('AlarmHistoryHeader.区分', '区分')} style={{ margin: '4px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="heavy"
                    onChange={(e) => setFlgHeavy(e.target.checked)}
                    checked={flgHeavy}
                    className={classes.checkstyle}
                  />
                }
                label={t('AlarmHistoryHeader.重故障', '重故障')}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="light"
                    onChange={(e) => setFlgLight(e.target.checked)}
                    checked={flgLight}
                    className={classes.checkstyle}
                  />
                }
                label={t('AlarmHistoryHeader.軽故障', '軽故障')}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="system"
                    onChange={(e) => setFlgSystem(e.target.checked)}
                    checked={flgSystem}
                    className={classes.checkstyle}
                  />
                }
                label={t('AlarmHistoryHeader.システム異常', 'システム異常')}
              />
              {/* <FormControlLabel
                control={
                  <Checkbox
                    name="mortor"
                    onChange={(e) => setFlgMotor(e.target.checked)}
                    checked={flgMotor}
                    className={classes.checkstyle}
                  />
                }
                label={t('AlarmHistoryHeader.モータ停止', 'モータ停止')}
              /> */}
            </GroupBox>
          </Grid>
          <Grid item xs={2}>
            <Button variant="contained" color="primary" className={classes.button} onClick={(e) => searchAlarm()}>
              {t('AlarmHistoryHeader.表示', '表示')}
            </Button>
            <Button
              disabled={!enableExport}
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={(e) => props.exportButton()}
            >
              {t('AlarmHistoryHeader.CSV出力', 'CSV出力')}
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <GroupBox name={t('AlarmHistoryHeader.条件', '条件')} style={{ margin: '0px 4px 4px 4px' }}>
            <span className={classes.searchName}>{t('AlarmHistoryHeader.機器番号', '機器番号')}</span>
            <TextField type="text" onChange={(e) => setDevNo(e.target.value)} value={devNo} style={{ width: '80px' }} />
            <span className={classes.searchName}>{t('AlarmHistoryHeader.機器名称', '機器名称')}</span>
            <TextField
              type="text"
              onChange={(e) => setDevName(e.target.value)}
              value={devName}
              style={{ width: '100px' }}
            />
            <span className={classes.searchName}>{t('AlarmHistoryHeader.項目名称', '項目名称')}</span>
            <TextField
              type="text"
              onChange={(e) => setItmName(e.target.value)}
              value={itmName}
              style={{ width: '120px' }}
            />
            <span className={classes.searchName}>{t('AlarmHistoryHeader.検索文字', '検索文字')}</span>
            <TextField
              type="text"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              style={{ width: '120px' }}
            />
            <span className={classes.searchName}>{t('AlarmHistoryHeader.を含む', 'を含む')}</span>
            <span style={{ margin: '4px 4px 4px 30px' }}>{t('AlarmHistoryHeader.最大', '最大')}</span>
            <TextField
              type="text"
              onChange={(e) => updateCount(e.target.value)}
              value={count}
              inputProps={{ maxlength: 5, style: { textAlign: 'center' } }}
              style={{ width: '60px', textAlign: 'center' }}
            />
            <span className={classes.searchName}>{t('AlarmHistoryHeader.件', '件')}</span>
          </GroupBox>
        </Grid>
      </Grid>
      {msgdlg}
    </>
  );
};

export default AlarmHistoryHeader;
